import React from "react";
import { FadeUp } from "@/components/motion/Reveal";

const chapters = [
  {
    n: "01",
    title: "Tell Advanced Life Policies about your current policy",
    body: "Share what you're paying today, plus a few basics about you. Three taps, no awkward phone calls, no medical exam for most people.",
  },
  {
    n: "02",
    title: "We shop the market for you",
    body: "A licensed Advanced Life Policies advisor compares dozens of top-rated insurers on your behalf and comes back with your best possible rate — often with more coverage than you have now.",
  },
  {
    n: "03",
    title: "Switch, save & lock it in",
    body: "Happy with your new number? Reserve the rate — we handle the switch with no gap in coverage. Peace of mind, delivered.",
  },
];

export default function Manifesto() {
  return (
    <section id="manifesto" className="relative bg-sand py-24 lg:py-32 grain overflow-hidden" data-testid="manifesto-section">
      <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-10">
        <FadeUp>
          <span className="text-xs tracking-[0.2em] uppercase font-bold text-sage">How it works</span>
          <h2 className="mt-4 font-serif font-light text-forest text-4xl sm:text-5xl lg:text-6xl leading-[0.98] tracking-tight max-w-2xl">
            Protection, arranged in three simple steps.
          </h2>
        </FadeUp>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-12 gap-y-12 md:gap-x-8">
          {chapters.map((c, i) => (
            <FadeUp
              key={c.n}
              delay={i * 0.12}
              className={
                i === 0
                  ? "md:col-span-5 md:col-start-1"
                  : i === 1
                  ? "md:col-span-5 md:col-start-7"
                  : "md:col-span-5 md:col-start-3"
              }
            >
              <div className="flex items-start gap-6">
                <span className="font-serif text-6xl lg:text-7xl text-terracotta/80 leading-none select-none">{c.n}</span>
                <div>
                  <h3 className="font-serif text-2xl lg:text-3xl text-forest tracking-tight">{c.title}</h3>
                  <p className="mt-3 text-forest/70 leading-relaxed max-w-sm">{c.body}</p>
                </div>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
